import { computed } from 'vue';
import type { RouteLocationNormalized } from 'vue-router';
import { useSidebarStore } from '@/vue/stores/sidebar';
import ROUTE_NAMES from '@/vue/routes/routeNames';
import {
    PLAYLIST_SIDEBAR_NAMES,
    type PlaylistSidebarName,
} from '../constants/sidebarNames';

const REVIEW_LIST_ROUTE_NAMES: ReadonlySet<string> = new Set([
    ROUTE_NAMES.REVIEW_LIST,
    ROUTE_NAMES.REVIEW_THUMBNAILS,
]);

const isReviewListRouteName = (name: RouteLocationNormalized['name']): boolean => (
    typeof name === 'string' && REVIEW_LIST_ROUTE_NAMES.has(name)
);

export const shouldPreservePlaylistSidebarOnRouteChange = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
): boolean => (
    isReviewListRouteName(to.name) && isReviewListRouteName(from.name)
);

export const isPlaylistSidebarName = (
    name: string | null | undefined,
): name is PlaylistSidebarName => (
    PLAYLIST_SIDEBAR_NAMES.some((playlistSidebarName) => playlistSidebarName === name)
);

export const useOpenedPlaylistSidebar = () => {
    const sidebarStore = useSidebarStore();

    return computed(() => {
        const { sidebar } = sidebarStore;
        if (!isPlaylistSidebarName(sidebar?.name)) {
            return null;
        }

        return sidebar;
    });
};
